import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { DateRangeValue } from '@shared/form-fields/date-range/date-range.value';
import { readableDateRange } from '@shared/utils/dates/readable-date-range';
import { isObject } from 'lodash-es';
import type { DateTime } from 'luxon';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'appDateRange' })
export class AppDateRangePipe implements PipeTransform {
    transform(value: [string | DateTime, string | DateTime] | DateRangeValue, includeTime: boolean = false, includeOnwards: boolean = true): string {
        let from: DateTime;
        let to: DateTime;

        console.log('value', toDateTime(value[0]), toDateTime(value[1]))

        if (Array.isArray(value)) {
            from = toDateTime(value[0]);
            to = toDateTime(value[1]);
        } else if (isObject(value)) {
            from = toDateTime(value.start);
            to = toDateTime(value.end);
        } else {
            return null;
        }

        return readableDateRange(from, to, includeTime, includeOnwards);
    }
}
